import { useContext } from "react";
import {
  ChatInternalContext,
  type IChatInternalContext,
} from "@b2bportal/core-chat";

export const useChatInternalContext = (): Partial<IChatInternalContext> => {
  const ctx = useContext(ChatInternalContext);
  if (ctx == null) throw new Error(`must be used within a ChatContextProvider`);
  return ctx;
};
